import http from "./httpClient.js";

export async function savePackage(data, payloadToken, schoolId) {
    const response = await http.post(`/school/${schoolId}/package`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function getAllPackageBySchool(payloadToken, schoolId) {
    const response = await http.get(`/school/${schoolId}/package`, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}

export async function updatePackage(packageId, data, payloadToken, schoolId) {
    const response = await http.patch(`/school/${schoolId}/package/${packageId}`, data, {
        headers: {
            Authorization: `Bearer ${payloadToken}`
        }
    });
    return response.data;
}